export default __webpack_public_path__ + "static/media/about-gallery-3-comp.fb5b92a7.png";